import React from "react";
import PropTypes from "prop-types";
import { getSampleDetailsSectionUrl } from "../../../../util";
import AnalysisTableRow from "../../AnalysisTableRow";
import { enums } from "../../../../../../shim/jsbridge";
import useParanoidMode from "../../../../../paranoid-mode/hooks/useParanoidMode";
import { INTEGRATION_ANALYSIS_METHOD } from "../../consts";
import { prepareHelpMessage } from "../utils";
import { prepareJoeResult } from "./utils";

const JoeTableRow = ({ joeData, resultJoe, sha1, sourceID, handleAction }) => {
  const {
    isProcessing,
    isConfigured,
    fileTypeSupported,
    fileOversized,
    neverSubmitted,
    last_completed_on,
    errorMessage
  } = joeData || {};

  const { paranoidModeConfig } = useParanoidMode();

  const joeImpactsClassification = paranoidModeConfig?.included?.includes(
    enums.paranoidModeComponents.JOE
  );

  const {
    JOE: { ICON, TITLE, SHORT_NAME }
  } = INTEGRATION_ANALYSIS_METHOD;

  return (
    <AnalysisTableRow
      icon={ICON}
      title={TITLE}
      shortName={SHORT_NAME}
      isProcessing={isProcessing}
      isConfigured={isConfigured}
      fileTypeSupported={fileTypeSupported}
      fileOversized={fileOversized}
      neverSubmitted={neverSubmitted}
      lastAnalysisTime={last_completed_on}
      result={prepareJoeResult(resultJoe)}
      helpMessage={prepareHelpMessage(joeData)}
      errorMessage={errorMessage}
      handleAction={() => handleAction(SHORT_NAME, TITLE)}
      noImpactOnClassification={!joeImpactsClassification}
      reportUrl={getSampleDetailsSectionUrl(SHORT_NAME, null, sha1, sourceID)}
    />
  );
};

JoeTableRow.propTypes = {
  joeData: PropTypes.shape({
    isProcessing: PropTypes.bool,
    isConfigured: PropTypes.bool,
    fileTypeSupported: PropTypes.bool,
    fileOversized: PropTypes.bool,
    neverSubmitted: PropTypes.bool,
    last_completed_on: PropTypes.string,
    errorMessage: PropTypes.string
  }).isRequired,
  resultJoe: PropTypes.arrayOf(PropTypes.object).isRequired,
  sha1: PropTypes.string.isRequired,
  sourceID: PropTypes.number.isRequired,
  handleAction: PropTypes.func
};

export default JoeTableRow;
